import React from "react";
import DealBannerImage1 from "@/assets/images/DealBanner01.png";
import DealBannerImage2 from "@/assets/images/DealBanner02.png";
import DealBannerImage3 from "@/assets/images/DealBanner03.png";
import DealBannerImage4 from "@/assets/images/DealBanner04.png";
import DealBannerImage5 from "@/assets/images/DealBanner05.png";
import DynamicImage from "@/components/DynamicImages/DynamicImage";

import Link from "next/link";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { useDispatch } from "react-redux";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";

const DealByCategory = () => {
  const [api, setApi] = React.useState(null);
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);

  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  // Function to go to a specific slide when clicking a dot
  const goToSlide = (index) => {
    if (api) {
      api.scrollTo(index);
    }
  };

  const dispatch = useDispatch();
  const updateBreadcrumb = (breadcrumb) => {
    dispatch(AddNewBreadcrum(breadcrumb));
  };

  return (
    <div className="pb-[48px] lg:pb-6">
      <Carousel
        opts={{ align: "start" }}
        className="w-full pb-0 "
        setApi={setApi}
      >
        <CarouselContent className="m-0">

          <CarouselItem
            className="basis-1/4 m-0 mlg:basis-1/3 viewedCard820:basis-1/2 viewedCard570:basis-3/4"
          >
            <div className=" shadow-[2px_4px_8px_0px_rgba(0,0,0,0.12)] rounded-[9px] m-[9px] bg-white overflow-hidden max-h-[calc(100%-18px)] h-full">
              <DynamicImage
                src={DealBannerImage1}
                alt="card-image"
                className="smd:h-[219px] w-full"
              />
              <div className=" px-2 pt-[17px] pb-[30px] flex flex-col items-center justify-center smd:pt-[17px] smd:pb-[23px] smd:px-3">
                <h2 className=" text-[#222222] text-[22px] font-semibold text-center smd:text-[18px]  ">
                  French Door Refrigerators
                </h2>
                <div className="my-5 text-[#222222] text-[14px] leading-[24px] text-center smd:my-3 smd:text-[11px]">
                  <p>In-Stock Refrigerators</p>
                  <p className=" font-medium">
Starting at $999</p>
                </div>
                <Link
                  href="/in-stock?subCategory2Ids=366"
                  className="  bg-[#16365F] rounded-[44px] min-h-[40px] px-[27px] py-[9px] text-white text-[14px] font-bold  smd:text-[11px] smd:min-h-[30px]"
                  onClick={() => {
                    updateBreadcrumb([
                      {
                        name: "French Door Refrigerators",
                        url: `/next-day-delivery?subCategory2Ids=366`,
                      }
                    ]);
                  }}
                >
                  Shop Refrigerators
                </Link>
              </div>
            </div>{" "}
          </CarouselItem>
          <CarouselItem
            className="basis-1/4 m-0 mlg:basis-1/3 viewedCard820:basis-1/2 viewedCard570:basis-3/4"
          >
            <div className=" shadow-[2px_4px_8px_0px_rgba(0,0,0,0.12)] rounded-[9px] m-[9px] bg-white overflow-hidden max-h-[calc(100%-18px)] h-full">
              <DynamicImage
                src={DealBannerImage2}
                alt="card-image"
                className="smd:h-[219px] w-full"
              />
              <div className=" px-4 pt-[17px] pb-[30px] flex flex-col items-center justify-center smd:pb-[23px] smd:px-3">
                <h2 className=" text-[#222222] text-[22px] font-semibold text-center smd:text-[18px] ">
                  Dishwashers
                </h2>
                <div className="my-5 text-[#222222] text-[14px] leading-[24px] text-center smd:my-3 smd:text-[11px]">
                  <p>In-Stock Dishwashers</p>
                  <p className=" font-medium">As low as $399</p>
                </div>
                <Link
                  href="/in-stock?categoryIds=350"
                  className="  bg-[#16365F] rounded-[44px] min-h-[40px] px-[27px] py-[9px] text-white text-[14px] font-bold smd:text-[11px] smd:min-h-[30px] text-center"
                  onClick={() => {
                    updateBreadcrumb([
                      {
                        name: "Dishwashers",
                        url: `/dishwashers`,
                      },
                    ]);
                  }}
                >
                  Shop Dishwashers
                </Link>
              </div>
            </div>{" "}
          </CarouselItem>
          <CarouselItem
            className="basis-1/4 m-0 mlg:basis-1/3 viewedCard820:basis-1/2 viewedCard570:basis-3/4"
          >
            <div className=" shadow-[2px_4px_8px_0px_rgba(0,0,0,0.12)] rounded-[9px] m-[9px] bg-white overflow-hidden max-h-[calc(100%-18px)] h-full">
              <DynamicImage
                src={DealBannerImage3}
                alt="card-image"
                className="smd:h-[219px] w-full"
              />
              <div className=" px-4 pt-[17px] pb-[30px] flex flex-col items-center justify-center smd:pb-[23px] smd:px-3">
                <h2 className=" text-[#222222] text-[22px] font-semibold text-center smd:text-[18px] ">
                  Gas Ranges
                </h2>
                <div className="my-5 text-[#222222] text-[14px] leading-[24px] text-center smd:my-3 smd:text-[11px]">
                  <p>In-Stock Ranges</p>
                  <p className=" font-medium">As low as $699</p>
                </div>
                <Link
                  href="/in-stock?subCategory2Ids=363"
                  className="  bg-[#16365F] rounded-[44px] min-h-[40px] px-[27px] py-[9px] text-white text-[14px] font-bold smd:text-[11px] smd:min-h-[30px] text-center"
                  onClick={() => {
                    updateBreadcrumb([
                      {
                        name: "Gas Ranges",
                        url: `/next-day-delivery?subCategory2Ids=363`,
                      },
                    ]);
                  }}
                >
                  Shop Ranges
                </Link>
              </div>
            </div>{" "}
          </CarouselItem>
          <CarouselItem
            className="basis-1/4 m-0 mlg:basis-1/3 viewedCard820:basis-1/2 viewedCard570:basis-3/4"
          >
            <div className=" shadow-[2px_4px_8px_0px_rgba(0,0,0,0.12)] rounded-[9px] m-[9px] bg-white overflow-hidden max-h-[calc(100%-18px)] h-full">
              <DynamicImage
                src={DealBannerImage4}
                alt="card-image"
                className="smd:h-[219px] w-full"
              />
              <div className=" px-4 pt-[17px] pb-[30px] flex flex-col items-center justify-center smd:pb-[23px] smd:px-3">
                <h2 className=" text-[#222222] text-[22px] font-semibold text-center smd:text-[18px] ">
                  Washer & Dryer Sets
                </h2>
                <div className="my-5 text-[#222222] text-[14px] leading-[24px] text-center smd:my-3 smd:text-[11px]">
                  <p>In-Stock Laundry Sets</p>
                  <p className=" font-medium">As low as $1,199</p>
                </div>
                <Link
                  href="laundry/washer-dryer-sets?page=1&isAvailabilty=true"
                  className="  bg-[#16365F] rounded-[44px] min-h-[40px] px-[27px] py-[9px] text-white text-[14px] font-bold smd:text-[11px] smd:min-h-[30px] text-center"
                  onClick={() => {
                    updateBreadcrumb([
                      {
                        name: "Washer & Dryer",
                        url: `/laundry/washer-dryer-sets`,
                      },
                    ]);
                  }}
                >
                  Shop Washer & Dryer Sets
                </Link>
              </div>
            </div>
          </CarouselItem>
          <CarouselItem
            className="basis-1/4 m-0 mlg:basis-1/3 viewedCard820:basis-1/2 viewedCard570:basis-3/4"
          >
            <div className=" shadow-[2px_4px_8px_0px_rgba(0,0,0,0.12)] rounded-[9px] m-[9px] bg-white overflow-hidden max-h-[calc(100%-18px)] h-full">
              <DynamicImage
                src={DealBannerImage5}
                alt="card-image"
                className="smd:h-[219px] w-full"
              />
              <div className=" px-4 pt-[17px] pb-[30px] flex flex-col items-center justify-center smd:pb-[23px] smd:px-3">
                <h2 className=" text-[#222222] text-[22px] font-semibold text-center smd:text-[18px] ">
                  Microwaves
                </h2>
                <div className="my-5 text-[#222222] text-[14px] leading-[24px] text-center smd:my-3 smd:text-[11px]">
                  <p>In-Stock Microwaves</p>
                  <p className=" font-medium">As low as $249</p>
                </div>
                <Link
                  href="/in-stock?subCategoryIds=352"
                  className="  bg-[#16365F] rounded-[44px] min-h-[40px] px-[27px] py-[9px] text-white text-[14px] font-bold smd:text-[11px] smd:min-h-[30px] text-center"
                  onClick={() => {
                    updateBreadcrumb([
                      {
                        name: "Microwaves",
                        url: `/next-day-delivery?subCategoryIds=352`,
                      },
                    ]);
                  }}
                >
                  Shop Microwaves
                </Link>
              </div>
            </div>{" "}
          </CarouselItem>
          {/* ))} */}
        </CarouselContent>

        <div className=" grid grid-cols-[1fr_auto] items-center gap-3 pl-[9px] ">
          {/* Clickable Pagination Dots */}
          <div className="flex justify-center ">
            {Array.from({ length: count }).map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-full h-1  transition-all ${
                  current === index + 1 ? "bg-black" : "bg-[#D0D0D0]"
                }`}
              />
            ))}
          </div>
          {/* Navigation Buttons */}
          <div className="flex items-center justify-end gap-3">
            <CarouselPrevious className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
            <div className="text-sm text-[#0C2340] font-medium">
              {current}/{count}
            </div>
            <CarouselNext className="ring-transparent bg-transparent relative top-auto right-auto left-auto bottom-auto translate-y-0" />
          </div>
        </div>
      </Carousel>
    </div>
  );
};

export default DealByCategory;